// extracted by mini-css-extract-plugin
export default {"body":"TableBody_body__ZWkii","empty":"TableBody_empty__HhQrd"};